import { endpointsMetadata } from "./endpointsMetadata";

// Communication Logs

export const constructEmailLogDetailEndpoint = (id: number) =>
  `${endpointsMetadata.communicationLogs.getEmailLogDetail}/${id}`;

export const constructCancelEmailEndpoint = (id: number) =>
  `${endpointsMetadata.communicationLogs.cancelEmail}/${id}`;

export const constructRetryEmailEndpoint = (id: number) =>
  `${endpointsMetadata.communicationLogs.retryEmail}/${id}`;

export const constructCancelSmsEndpoint = (id: number) =>
  `${endpointsMetadata.communicationLogs.cancelSms}/${id}`;
